<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="createSchedule" (change)="createScheduleChange()" (submit)="createScheduleSubmit()">



        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{"SCHDEDULE_CREATE" | translate | titlecase }}</h6>
            </div>
            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="button" class="btn btn-outline-secondary m-2 rounded-0" routerLink="/schedule/schedule"
                    *ngIf="!creating">
                    {{"CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i
                        class="fas fa-user-plus"></i>
                    {{"SAVE" | translate | titlecase }}</button>
                <app-loader [show]="creating"></app-loader>
            </div>


        </div>

        <div class="row mt-4">
            <div class="col-12">
                <div class="row bg-white border m-0 py-3 ">
                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"EFFECTIVE_DATE_FROM" | translate | titlecase }}</label>
                                <input type="date" class="form-control" formControlName="effectiveDateFrom">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createSchedule.controls.effectiveDateFrom.touched && createSchedule.controls.effectiveDateFrom.invalid && createSchedule.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"EFFECTIVE_DATE_TO" | translate | titlecase }}</label>
                                <input type="date" class="form-control" formControlName="effectiveDateTo">
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"STATUS" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="status">
                                    <option value="" selected>{{"SELECT" | translate | titlecase }}</option>
                                    <option value="UNLOCKED">{{"UNLOCK" | translate | titlecase }}</option>
                                    <option value="LOCKED">{{"LOCK" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createSchedule.controls.status.touched && createSchedule.controls.status.invalid && createSchedule.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ACTIVE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="active">
                                    <option value="" selected>{{"SELECT" | translate | titlecase }}</option>
                                    <option value="YES">{{"YES" | translate | titlecase }}</option>
                                    <option value="NO">{{"NO" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createSchedule.controls.active.touched && createSchedule.controls.active.invalid && createSchedule.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>